module.exports = __webpack_public_path__ + "static/media/draft.c59a9479.svg";